import React from 'react'
import useExperiencePurchaseDetails from 'hooks/Experiences/useExperiencePurchaseDetails'
import TextButton from 'components/Luxkit/Button/TextButton'
import LineHotAirBalloonIcon from 'components/Luxkit/Icons/line/LineHotAirBalloonIcon'
import StatusLabel from 'components/Luxkit/Label/StatusLabel'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import CaptionTextBlock from 'components/Luxkit/TextBlocks/CaptionTextBlock'
import Group from 'components/utils/Group'
import LesaPurchaseSummaryContainer from './Common/LesaPurchaseSummaryContainer'
import LesaPurchaseSummaryHeader from './Common/LesaPurchaseSummaryHeader'
import LesaPurchaseSummarySeparator from './Common/LesaPurchaseSummarySeparator'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Action, { ActionsList } from '../../Chat/MessageMeta/Action'
import { filterActions } from '../../../utils/actionsUtils'
import { ChatActions, ContentTypes, MessageMetaContent, MessageMetaPayload } from 'api/support'

interface Props {
  order: App.Order;
  isPastOrder: boolean;
  hideSelect?: boolean;
  actions?: MessageMetaContent[];
  componentsMap: Map<string | undefined, MessageMetaContent>;
  payload?: MessageMetaPayload
  handleAction: (message: string, meta: any) => void;
}

function LesaExperiencePurchaseSummary(props: Props) {
  const { order, isPastOrder, hideSelect } = props
  const { actions, handleAction, payload, componentsMap } = props
  const {
    location,
    name,
    bookingNumber,
    experienceDate,
    experienceTime,
  } = useExperiencePurchaseDetails(order, isPastOrder)

  const orderActions = actions?.filter(action => filterActions(action, isPastOrder, ['listInclusions', 'showFinePrint']))

  return (
    <>
      {(!!componentsMap?.get(ContentTypes.LIST_ORDERS) || !!componentsMap?.get(ChatActions.SELECT_ORDER)) && (
        <LesaPurchaseSummaryContainer>
          <LesaPurchaseSummaryHeader>
            <BodyTextBlock lineClamp={2} variant="small" startIcon={<LineHotAirBalloonIcon size="XS" />}>Experience</BodyTextBlock>
            {!isPastOrder && <StatusLabel variant="confirmation">Upcoming</StatusLabel>}
            {isPastOrder && <StatusLabel variant="pending">Past</StatusLabel>}
          </LesaPurchaseSummaryHeader>
          <Group direction="vertical">
            <Group direction="vertical" gap={4}>
              {location && <CaptionTextBlock
                variant="medium"
                colour="neutral-three"
              >{location}</CaptionTextBlock>}
              <BodyTextBlock lineClamp={2} weight="bold" variant="medium">{name}</BodyTextBlock>{' '}
              <LesaPurchaseSummarySeparator>
                {experienceDate && <BodyText as="span" variant="small" colour="neutral-two">{experienceDate}</BodyText>}
                {experienceTime && <BodyText as="span" variant="small" colour="neutral-two">{experienceTime}</BodyText>}
              </LesaPurchaseSummarySeparator>
              {bookingNumber && <BodyTextBlock variant="small" colour="neutral-two"><strong>Booking ID:</strong> {bookingNumber}</BodyTextBlock>}{' '}
            </Group>
          </Group>
          {!hideSelect && <Group fullWidth direction="horizontal" horizontalAlign="end" verticalAlign="end">
            <TextButton onClick={() => handleAction?.('', { key: ChatActions.SELECT_ORDER, payload: { id_orders: order.id } })} fit="mobile-full-width" size="small" kind="secondary">Select</TextButton>
          </Group>}
        </LesaPurchaseSummaryContainer>
      )}
      {!!orderActions?.length && <ActionsList>
        {orderActions.map((action) => (
          <Action key={action.action?.key} action={action} payload={payload} handleAction={handleAction} />
        ))}
      </ActionsList>}
    </>
  )
}

export default LesaExperiencePurchaseSummary
